import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/profile-components/Navbar";
import Topbar from "../../components/profile-components/Topbar";
import API_BASE_URL from "../../config";
import "../../pages/SalesPages.css";

function SubscriptionPlans() {
  const navigate = useNavigate();

  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadPlans();
  }, []);

  const loadPlans = async () => {
    try {
      setLoading(true);

      const token = localStorage.getItem("token");

      const res = await fetch(`${API_BASE_URL}/api/subscription-plans/admin`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.message || "Failed to load subscription plans");
      }

      setPlans(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("Load subscription plans error:", err.message);
      setPlans([]);
    } finally {
      setLoading(false);
    }
  };

  const formatPrice = (value) => {
    if (value === null || value === undefined || value === "") return "—";
    return `$${Number(value).toFixed(2)}`;
  };

  const formatMaxUsers = (value) => {
    if (value === null || value === undefined || value === "") return "Unlimited";
    return value;
  };

  return (
    <>
      <Navbar />
      <Topbar />

      <div className="main-content sales-page">
        <div className="sales-hero">
          <div>
            <p className="sales-eyebrow">Agent Book CRM</p>
            <h1 className="sales-title">Subscription Plans</h1>
            <p className="sales-subtitle">
              Manage plan names, user limits, pricing, active status, and plan feature access.
            </p>
          </div>

          <div className="sales-header-actions">
            <button
              className="sales-primary-btn"
              onClick={() => navigate("/settings/subscription-plans/new")}
            >
              + New Plan
            </button>
          </div>
        </div>

        <div className="sales-table-card">
          <div className="sales-table-header">
            <div>
              <h2>All Plans</h2>
              <p>
                {plans.length} plan{plans.length === 1 ? "" : "s"}
              </p>
            </div>
          </div>

          <div className="sales-table-wrap">
            <table className="sales-table">
              <thead>
                <tr>
                  <th>Plan</th>
                  <th>Description</th>
                  <th>Max Users</th>
                  <th>Monthly</th>
                  <th>Annual</th>
                  <th>Custom Pricing</th>
                  <th>Active</th>
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="7" className="sales-empty-cell">
                      Loading subscription plans...
                    </td>
                  </tr>
                ) : plans.length === 0 ? (
                  <tr>
                    <td colSpan="7" className="sales-empty-cell">
                      No subscription plans found.
                    </td>
                  </tr>
                ) : (
                  plans.map((plan) => (
                    <tr
                      key={plan.id}
                      className="sales-click-row"
                      onClick={() => navigate(`/settings/subscription-plans/${plan.id}`)}
                    >
                      <td>
                        <div className="sales-primary-cell">
                          <div className="sales-name">{plan.plan_name}</div>
                          <div className="sales-secondary">{plan.plan_key}</div>
                        </div>
                      </td>

                      <td>{plan.description || "—"}</td>
                      <td>{formatMaxUsers(plan.max_users)}</td>
                      <td>{formatPrice(plan.monthly_price)}</td>
                      <td>{formatPrice(plan.annual_price)}</td>
                      <td>{plan.is_custom_pricing ? "Yes" : "No"}</td>
                      <td>{plan.is_active ? "Yes" : "No"}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}

export default SubscriptionPlans;